const state = {
  ProductsOverview: {},
  RegistrationForm: {},
  ProductDetail: {},
  ServiceForm: {},
  ShoppingCart: {},
  Checkout: {},
  ProjectOverview: {},
  MachineOverview: {},
  ToastNotification: {},
  ToolingOverview: {},
  Paging: {},
  OrderOverview: {},
  QuotationOverview: {},
  InvoiceOverview: {},
  MachineForm: {},
  ToolingForm: {},
  QuoteDetail: {},
  BaseShapeDetail: {},
  OrderDetail: {},
  PromoCodeOverview: {},
  PromoCodeForm: {},
  VoucherOverview: {},
  AddVoucher: {},
  CustomerDashboard: {},
  SpareParts: {}
};

const actions = {
  async getTranslations({ commit }, payload) {
    const { culture, dictionaryKey } = payload;

    const translationData = await fetch(
      `/umbraco/api/translations/getalltranslations?locale=${culture}&dictionaryKey=${dictionaryKey}`
    )
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => console.error(error));

    const payloadData = {
      key: dictionaryKey,
      data: translationData
    };

    if (translationData) {
      commit('setTranslations', payloadData);
    }
  }
};

const mutations = {
  setTranslations(state, payload) {
    const { key, data } = payload;
    state[key] = data;
  }
};

const getters = {
  getCustomerDashboardTranslations(state) {
    return state.CustomerDashboard;
  },
  getAddVoucherTranslations(state) {
    return state.AddVoucher;
  },
  getPromoCodeOverviewTranslations(state) {
    return state.PromoCodeOverview;
  },
  getPromoCodeFormTranslations(state) {
    return state.PromoCodeForm;
  },
  getVoucherOverviewTranslations(state) {
    return state.VoucherOverview;
  },
  getOrderDetailTranslations(state) {
    return state.OrderDetail;
  },
  getBaseShapeDetailTranslations(state) {
    return state.BaseShapeDetail;
  },
  getQuotationOverviewTranslations(state) {
    return state.QuotationOverview;
  },
  getOrderOverviewTranslations(state) {
    return state.OrderOverview;
  },
  getPagingTranslations(state) {
    return state.Paging;
  },
  getInvoiceOverviewTranslations(state) {
    return state.InvoiceOverview;
  },
  getToolingOverviewTranslations(state) {
    return state.ToolingOverview;
  },
  getMachineOverviewTranslations(state) {
    return state.MachineOverview;
  },
  getProductOverviewTranslations(state) {
    return state.ProductsOverview;
  },
  getRegistrationFormTranslations(state) {
    return state.RegistrationForm;
  },
  getProductPageTranslations(state) {
    return state.ProductDetail;
  },
  getServiceFormTranslations(state) {
    return state.ServiceForm;
  },
  getShoppingCartTranslations(state) {
    return state.ShoppingCart;
  },
  getCheckoutTranslations(state) {
    return state.Checkout;
  },
  getProjectOverviewTranslations(state) {
    return state.ProjectOverview;
  },
  getToastNotificationTranslations(state) {
    return state.ToastNotification;
  },
  getToolingFormTranslations(state) {
    return state.ToolingForm;
  },
  getMachineFormTranslations(state) {
    return state.MachineForm;
  },
  getQuoteDetailTranslations(state) {
    return state.QuoteDetail;
  },
  getSparePartsTranslations(state) {
    return state.SpareParts;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
